export default __webpack_public_path__ + "static/mob-img02-a9eb3c0bd8afb7024fa5493ff3762f2a.png";